// src/components/Main/Main.js

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './Main.css';
import { PopupProvider } from '../../context/PopupContext';
import Popup from '../routes/Other/Popup/Popup';

const Afirst = lazy(() => import('../routes/Afirst/Afirst'));
const Landing = lazy(() => import('../routes/Landing/Landing'));
const Dashboard = lazy(() => import('../routes/Dashboard/Dashboard'));
const WhatsAppScanner = lazy(() => import('../routes/Other/Whatsapp/Whatsapp'));
const UseForm = lazy(() => import('../routes/Forms/UseForm/UseForm'));

// PopupWrapper component to render the Popup
const PopupWrapper = () => {
    return <Popup />;
};

const Main = () => {
  // Determine if user is logged in (using the same approach as in your existing authentication system)
  const isLoggedIn = localStorage.getItem('token') || sessionStorage.getItem('token');
    return (
        <Router>
            <PopupProvider>
                {/* Render Popup component */}
                <PopupWrapper />
                
                {isLoggedIn && (
                    <Suspense fallback={null}>
                        <WhatsAppScanner />
                    </Suspense>
                )}
                
                {/* Main content */}
                <div className="main-content">
                    <Suspense fallback={<div className="route-loading-state">Loading page…</div>}>
                        <Routes>
                            {/* Route to the Landing component at the root path */}
                            <Route path="/" element={<Landing />} />

                            {/* Business Head / Super Admin Dashboard */}
                            <Route path="/dashboard" element={<Dashboard />} />

                            {/* Direct callback opened by UCP after a call starts */}
                            <Route path="/phone/:phone_no" element={<UseForm />} />

                            {/* Add a route for the Afirst component */}
                            <Route path="*" element={<Afirst />} />
                        </Routes>
                    </Suspense>
                </div>
            </PopupProvider>
        </Router>
    );
};

export default Main;
